var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-container" },
    [
      _c(
        "el-button",
        {
          attrs: { size: "mini", type: "primary" },
          on: {
            click: function ($event) {
              _vm.dialogVisible = true
            },
          },
        },
        [_vm._v(" 上傳 ")]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.title,
            "append-to-body": "",
            width: _vm.device == "mobile" ? "90%" : "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "dialog-content",
            },
            [
              _c(
                "div",
                { staticClass: "album-group__dialog" },
                [
                  _c(
                    "div",
                    { staticClass: "album-group__create" },
                    [
                      _c("el-input", {
                        staticClass: "album-group__input",
                        attrs: {
                          type: "text",
                          size: "small",
                          placeholder: "請輸入相簿名稱",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleAddAlbum($event)
                          },
                        },
                        model: {
                          value: _vm.newAlbumName,
                          callback: function ($$v) {
                            _vm.newAlbumName =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "newAlbumName",
                        },
                      }),
                      _c(
                        "el-button",
                        {
                          staticClass: "album-group__button",
                          attrs: {
                            type: "primary",
                            plain: "",
                            size: "small",
                            icon: "el-icon-folder-add",
                          },
                          on: { click: _vm.handleAddAlbum },
                        },
                        [_vm._v("新增相簿")]
                      ),
                    ],
                    1
                  ),
                  _vm._l(_vm.albumGroupTag, function (groupTag) {
                    return _c(
                      "div",
                      {
                        key: groupTag.id,
                        staticClass: "album-group album-group--desktop",
                        on: {
                          click: function ($event) {
                            return _vm.handleSelectGroupTag(groupTag)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "album-content" },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  gap: "0 8px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "icon-container" },
                                  [
                                    _c("el-icon", {
                                      staticClass: "icon-folder",
                                      class: {
                                        "icon-folder--active":
                                          _vm.selectedAlbumGroupTag.id ==
                                          groupTag.groupTagId,
                                      },
                                      attrs: { name: "folder" },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "album-group__name",
                                    class: {
                                      "album-group__name--active":
                                        _vm.selectedAlbumGroupTag.id ==
                                        groupTag.groupTagId,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(groupTag.groupTagName) + " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "el-popconfirm",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !!groupTag.groupTagId,
                                    expression: "!!groupTag.groupTagId",
                                  },
                                ],
                                attrs: {
                                  title: "確定要刪除此相簿嗎?",
                                  "confirm-button-text": "確認",
                                  "cancel-button-text": "取消",
                                },
                                on: {
                                  confirm: function ($event) {
                                    return _vm.handleDeleteConfirm(
                                      groupTag.groupTagId
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "icon-container__delete",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _c("el-icon", {
                                      staticClass: "icon-delete",
                                      attrs: { name: "delete" },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "album-group__container" },
                _vm._l(_vm.albumGroupTag, function (groupTag) {
                  return _c(
                    "div",
                    {
                      key: groupTag.id,
                      staticClass: "album-group",
                      class: {
                        "album-group--active":
                          _vm.selectedAlbumGroupTag.id == groupTag.groupTagId,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleSelectGroupTag(groupTag)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            display: "flex",
                            gap: "8px",
                            "justify-content": "space-between",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                gap: "0 8px",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "icon-container" },
                                [
                                  _c("el-icon", {
                                    staticClass: "icon-folder",
                                    class: {
                                      "icon-folder--active":
                                        _vm.selectedAlbumGroupTag.id ==
                                        groupTag.groupTagId,
                                    },
                                    attrs: { name: "folder" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "album-group__name",
                                  class: {
                                    "album-group__name--active":
                                      _vm.selectedAlbumGroupTag.id ==
                                      groupTag.groupTagId,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(groupTag.groupTagName) + " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "el-popconfirm",
                            {
                              attrs: {
                                title: !groupTag.groupTagId
                                  ? "是否要刪除未分類相簿內所有照片？"
                                  : "確定要刪除此相簿嗎?",
                                "confirm-button-text": "確認",
                                "cancel-button-text": "取消",
                              },
                              on: {
                                confirm: function ($event) {
                                  return _vm.handleDeleteConfirm(
                                    groupTag.groupTagId
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "icon-container__delete",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _c("el-icon", {
                                    staticClass: "icon-delete",
                                    attrs: { name: "delete" },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                { staticClass: "uploadImage__dialog" },
                [
                  _c(
                    "p",
                    { staticClass: "uploadImage__dialog__title" },
                    [
                      _c("span", [_vm._v("上傳至：")]),
                      _c("el-icon", {
                        staticClass: "icon-folder icon-folder--active",
                        attrs: { name: "folder" },
                      }),
                      _c("span", { staticStyle: { "font-weight": "500" } }, [
                        _vm._v(_vm._s(_vm.selectedAlbumGroupTag.name)),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-upload",
                    {
                      ref: "uploadAgencyAlbumImage",
                      staticClass: "editor-slide-upload",
                      attrs: {
                        multiple: true,
                        action: "#",
                        accept: "image/*",
                        "on-remove": _vm.handleRemove,
                        "on-success": _vm.handleSuccess,
                        "on-change": _vm.handleUploadChange,
                        "before-upload": _vm.beforeUpload,
                        "list-type": "picture-card",
                        "auto-upload": false,
                      },
                      model: {
                        value: _vm.fileList,
                        callback: function ($$v) {
                          _vm.fileList = $$v
                        },
                        expression: "fileList",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { type: "text", icon: "el-icon-plus" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "footer",
            { staticClass: "uploadImage__footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.loading },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(" 取消 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.loading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v(" 確認 ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }